import React from "react"
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share"

import facebook from "../assets/images/share-icons/facebook.svg"
// import instagram from "../assets/images/share-icons/instagram.svg"
import linkedin from "../assets/images/share-icons/linkedin.svg"
import x from "../assets/images/share-icons/x.svg"
import share from "../assets/images/share-icons/share.svg"

const ShareList = ({ label, url }) => {
  return (
    <div className="share-list">
      <strong>{label ?? "Share"}</strong>
      <FacebookShareButton url={url}>
        <img src={facebook} alt="" />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <img src={x} alt="" />
      </TwitterShareButton>
      <LinkedinShareButton url={url}>
        <img src={linkedin} alt="" />
      </LinkedinShareButton>
      <EmailShareButton url={url}>
        <img src={share} alt="" />
      </EmailShareButton>
    </div>
  )
}

export default ShareList
